import CustomRoute from '../../beatport/content/CustomRoute';
export default CustomRoute;